<template>
  <el-dialog title="结佣二次确认" width="50%" :visible.sync="value" modal-append-to-body append-to-body class="verify"
    @close="onCancel">
    <div>
      <el-alert title="您正在提交代理结佣，请再次确认信息无误！" type="error" :closable="false" />
      <div class="verify-tip verify-tip__red verify-tip__red--right">
        本次结佣：
      </div>
      <div class="verify-content">
        <div>
          结佣周期：<span>{{ form.time[0] }}~{{ form.time[1] }}</span>
        </div>
        <div>
          结佣方式：<span>{{
            form.settleType === 0 ? '常规结佣' : '特殊结佣'
          }}</span>
        </div>
        <div v-if="form.settleType === 1">
          结佣比例：<span>{{ form.settleRatio }}%</span>
        </div>
        <div>
          结佣代理：<span>{{
            form.isSettleAllUser === 1 ? '所有代理' : '部分代理'
          }}</span>
        </div>
        <div v-if="form.isSettleAllUser === 0 && form.userUUID && form.userUUID.length
          " class="verify-userUUId">
          <el-tag v-for="(item, index) in form.userUUID" :key="index" class="tag" color="tag" type="info"
            :disable-transitions="true">
            {{ item.nickname }}</el-tag>
        </div>
        <div>
          总结佣金额：<span class="verify-tip__red">{{ allCommission }}元</span>
        </div>
      </div>
      <div class="verify-tip verify-tip__red verify-tip__red--left">
        是否确认进行本次结佣？
      </div>
    </div>
    <span slot="footer" class="verify-footer">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" :loading="loading" @click="onSure">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import douYin from "@/javaApi/douyin";
const DouYinModel = new douYin();

export default {
  props: {
    fillCommission: {
      // 差价的对象
      type: Object,
      default: () => { }
    },
    value: {
      // 是否显示弹框
      type: Boolean,
      default: false
    },
    allCommission: {
      // 总结佣金额
      type: String,
      default: '0'
    },
    form: {
      // 表单数据
      type: Object,
      default: () => { }
    }
  },

  data() {
    return {
      loading: false // 加载
    }
  },

  methods: {
    // 取消
    onCancel() {
      this.loading = false
      this.$emit('input', false)
    },
    // 确定
    async onSure() {
      this.loading = true
      const params = {
        startDate: this.form.time && this.form.time.length ? this.form.time[0] : '',
        endDate: this.form.time && this.form.time.length ? this.form.time[1] : '',
        settleType: this.form.settleType,
        isSettleAllUser: this.form.isSettleAllUser,
        miniAppType:5
      }

      // 特殊结佣
      if (params.settleType === 1) {
        params.settleRatio = this.form.settleRatio
      }
      // 部分代理
      if (params.isSettleAllUser === 0) {
        params.userUUIDStr = this.form.userUUID
          .map((item) => item.userUUID)
          .join(',')
      }
      // 传递给后端进行核对
      params.settledCommissionTotal = this.allCommission
      // 传递给后端补差的数据
      params.fillCommissionJsonStr =
        this.fillCommission && Object.keys(this.fillCommission).length
          ? JSON.stringify(this.fillCommission)
          : ''

      const data = await DouYinModel.onSettlementSubmit(params).finally(() => {
        this.loading = false
      })

      if (data.data.code === 200) {
        this.$message.success(data.data.message || data.data.info)
        this.onCancel()
        this.$emit('successSubmit')
      } else {
        this.$message.error(data.data.message || data.data.info)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.verify {
  &-userUUId {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 10px 0 10px;
    border: 1px dashed #dcdfe6;
    border-radius: 2px;
    margin-bottom: 20px;
    max-height: 200px;

    &>.el-tag {
      margin: 0 10px 10px 0px;
    }
  }

  &-toolbar {
    padding: 0 10px;
    margin-bottom: 20px;
  }

  &-content {
    margin: 0 40px;

    &>div {
      line-height: 40px;

      &>span {
        font-weight: bold;
      }
    }
  }

  &-tip {
    &__red {
      color: red;
      font-weight: bold;

      &--left {
        text-align: right;
        padding-top: 20px;
      }

      &--right {
        padding: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/userData/SubmitVerify.vue